import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faBars } from '@fortawesome/free-solid-svg-icons';
import Button from '~/elements/Button';
import ObituaryLink from '~/elements/ObituaryLink';
import VenueLogo from '~/elements/VenueLogo';
import ArrowIcon from '~/assets/arrow';
import ErrorIcon from '~/assets/error';
import HeadphoneIcon from '~/assets/headphone';
import QuestionIcon from '~/assets/question';
import NoSoundIcon from '~/assets/nosound';
import { checkIsAbsolute, isFuneralHome, isPlanAheadAvailable } from '~/utils/helpers';
import { newColors } from '~/themes/variables';
import styles from './header.style';
import PreNeedButton from '~/elements/PreNeedButton';
import { Feature, Stage } from '~/types/common';
import { featureOn } from '~/utils/featureToggle';
const PLAN_AHEAD_ENABLED = featureOn(Feature.plan_ahead);
const Header = styled.header `
  ${styles}
`;
const TechQuestions = [
    {
        icon: NoSoundIcon,
        alt: 'No Audio',
        question: 'Can\'t hear the service?',
        link: 'https://support.oneroomstreaming.com/knowledge/why-cant-i-hear-the-service',
        buttonLabel: 'View suggestions',
    },
    {
        icon: ErrorIcon,
        alt: 'Error',
        question: 'Error message?',
        link: 'https://support.oneroomstreaming.com/knowledge/im-getting-an-error-message-what-does-it-mean',
        buttonLabel: 'View what it means',
    },
];
const HelpQuestion = [
    {
        icon: QuestionIcon,
        alt: 'Registraion',
        question: 'Questions about Registration?',
        link: 'https://support.oneroomstreaming.com/knowledge/registration-form-help',
        buttonLabel: 'View registration guide',
    },
];
const HeaderComponent = ({ logo, obituaryLink, registerForm = false, venueType, }) => {
    const [techSupportVisible, setTechSupportVisible] = useState(false);
    const buttonRef = useRef(null);
    const toggleTechSupportVisibility = useCallback(() => {
        console.log('techSupportVisible:', techSupportVisible);
        setTechSupportVisible((v) => !v);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            // @ts-ignore
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setTechSupportVisible(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    const questions = registerForm ? HelpQuestion : TechQuestions;
    return (_jsxs(Header, { children: [_jsx(VenueLogo, { logo: logo, maxHeight: 80, maxWidth: 350, smallerOnMobile: true }), _jsxs("div", { className: "support-button", children: [_jsx("div", { className: "mobile-menu", ref: buttonRef, children: _jsx(Button, { icon: {
                                position: 'left',
                                element: _jsx(FontAwesomeIcon, { icon: faBars, color: newColors.purple500 }),
                            }, clear: true, onClick: toggleTechSupportVisibility, hoverBackgroundColor: newColors.purple200, children: ' ' }) }), obituaryLink?.link && (_jsx("div", { className: "header-button", children: _jsx(ObituaryLink, { link: obituaryLink.link }) })), PLAN_AHEAD_ENABLED && isPlanAheadAvailable() && isFuneralHome(venueType) && (_jsx("div", { className: "header-button", children: _jsx(PreNeedButton, { page: Stage.waitingRoom }) })), _jsx("div", { className: "header-button", ref: buttonRef, children: _jsx(Button, { icon: {
                                position: 'left',
                                element: registerForm ? (_jsx(HeadphoneIcon, {})) : (_jsx(FontAwesomeIcon, { icon: faQuestionCircle })),
                            }, onClick: toggleTechSupportVisibility, children: registerForm ? 'Need Help?' : 'Tech Support' }) }), _jsx("div", { className: classNames('tech-support-container', {
                            'tech-support-visible': techSupportVisible,
                        }), children: _jsxs("div", { className: "tech-support-inner-container", children: [questions.map((question) => (_jsxs("div", { className: "tech-support-block", children: [_jsxs("div", { className: "tech-support-row", children: [_jsx("div", { className: "tech-support-message", children: question.question }), _jsx("div", { className: "tech-support-icon-container", children: _jsx(question.icon, { fill: newColors.purple500 }) })] }), _jsx("a", { className: "tech-support-link", href: question.link, target: "_blank", rel: "noreferrer", children: _jsx("button", { type: "submit", className: "tech-support-button", children: question.buttonLabel }) })] }, question.link))), obituaryLink?.link && (_jsx("div", { className: "obituary-link", children: _jsxs("div", { className: "tech-support-row", children: [_jsx("a", { className: "tech-support-message tech-support-link", href: checkIsAbsolute(obituaryLink.link)
                                                    ? obituaryLink.link
                                                    : `//${obituaryLink.link}`, target: "_blank", rel: "noreferrer", children: "Obituary Page" }), _jsx("div", { className: "obituary-icon-container", children: _jsx(ArrowIcon, {}) })] }) })), _jsxs("div", { className: "tech-support-footer", children: [_jsx("p", { className: "tech-support-phrase", children: "For other enquires, please contact us:" }), _jsx("p", { className: "tech-support-phrase", children: _jsx("a", { href: "mailto:support@oneroomstreaming.com", children: "support@oneroomstreaming.com" }) })] })] }) })] })] }));
};
export default HeaderComponent;
